import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { Panel, PanelHeader, PanelBody } from '../../../components/admin/panel/panel';
import { bannersActions } from '../../../store/banners';
import { breadcrumb } from '../../../helpers/page-admin';

class Create extends React.Component {

    constructor(props) {
        super(props);

        const user = JSON.parse(localStorage.getItem('user'));
        this.state = {
            category: this.props.match.params.c,
            subCategory: this.props.match.params.s,
            name: user.name,
            title: '',
            summary: '',
            option: '',
            link: '',
            target: '_self',
            formFile: null,
            formFile2: null,

            submitted: false
        };
    }

    async onSubmit(event) { 
        event.preventDefault();
        const { category, subCategory, name, title, summary, option } = this.state;
        if (category && subCategory && name && title && summary && option) {
            await this.props.postBanner(this.state);
            await this.props.history.push(`/admin/banners/${category}/${subCategory}`);
        } else this.setState({ submitted: true });
    }

    onChange(event) {
        const { name, value } = event.target;
        this.setState({ [name]: value });
    }

    onChangeFile(event) {
        const file = event.target.files[0];
        if (event.target.name === 'formFile') this.setState({ formFile: file ? file : null });
        else if (event.target.name === 'formFile2') this.setState({ formFile2: file ? file : null });
    }

    render() {
        //console.log(this.state.subCategory);
        const { title, summary, option, submitted } = this.state;
        return (
            <div>
                <h1 className="page-header">{breadcrumb(this.props).title}</h1>
                <Panel>
                    <PanelHeader>등록</PanelHeader>
                    <PanelBody>
                        <form onSubmit={(e) =>this.onSubmit(e)} encType="multipart/form-data" method="post">
                            <div className="form-group">
                                <label className="control-label">제목</label>
                                <input onChange={(e) => this.onChange(e)} name="title" className="form-control" />
                                {submitted && !title && <div className="help-block text-danger">필수 입력 항목입니다.</div>}
                            </div>
                            <div className="form-group">
                                <label className="control-label">부제목</label>
                                <input onChange={(e) => this.onChange(e)} name="summary" className="form-control" />
                                {submitted && <div className="help-block text-danger">필수 입력 항목입니다.</div>}
                            </div>
                            <div className="form-group">
                                <label className="control-label">백그라운드 컬러</label>
                                <input onChange={(e) => this.onChange(e)} name="option" className="form-control" placeholder="#6AAAE4"/>
                                {submitted && <div className="help-block text-danger">필수 입력 항목입니다.</div>}
                            </div>
                            <div className="form-group">
                                <label className="control-label">링크주소</label>
                                <input onChange={(e) => this.onChange(e)} name="link" className="form-control" />
                            </div>
                            <div className="form-group">
                                <label>링크방식</label>
                                <select onChange={(e) => this.onChange(e)} name="target" className="form-control">
                                    <option value="_self">_self : 현재창에서 열기</option>
                                    <option value="_blank">_blank : 새창으로 열기</option>
                                </select>
                            </div>
                            <div className="row">
                                <div className="col-6">
                                    <div className="form-group p-t-10">
                                        <label className="control-label">이미지1</label>
                                        <input onChange={(e) => this.onChangeFile(e)} name="formFile" className="form-control-file" type="file" />
                                        {this.state.subCategory === 'main' && <small className="text-muted g-font-size-10">Note: 660 x 410</small>}
                                        {this.state.subCategory === 'side' && <small className="text-muted g-font-size-10">Note: 400 X 250</small>}
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="form-group p-t-10">
                                        <label className="control-label">이미지2</label>
                                        <input onChange={(e) => this.onChangeFile(e)} name="formFile2" className="form-control-file" type="file" />
                                        {this.state.subCategory === 'main' && <small className="text-muted g-font-size-10">Note: 640 X 600</small>}
                                        {this.state.subCategory === 'side' && <small className="text-muted g-font-size-10">Note: 400 X 250</small>}
                                    </div>
                                </div>
                            </div>

                            <div className="form-group text-right p-t-15">
                                <Link to={`/admin/banners/${this.state.category}/${this.state.subCategory}`} className="btn btn-success rounded-0 m-r-5">목록</Link>
                                <button type="submit" className="btn btn-inverse rounded-0">등록</button>
                            </div>

                        </form>

                    </PanelBody> 
                </Panel>
            </div>
        )
    }
}

export default connect(
    state => ({ banners: state.banners }),
    dispatch => bindActionCreators({ ...bannersActions }, dispatch)
)(withRouter(Create));


// WEBPACK FOOTER //
// ./src/pages/admin/banners/create.js